module.exports = __webpack_public_path__ + "static/media/github_pattern_white.51748dcc.svg";